import instantReqTypes from "./instantReq.types";

export const setInstantStep = (step) => ({
  type: instantReqTypes.SET_STEP,
  payload: step,
});
export const fetchStatusStart = () => ({
  type: instantReqTypes.FETCH_STATUS_START,
});

export const fetchStatusSuccess = (res) => ({
  type: instantReqTypes.FETCH_STATUS_SUCCESS,
  payload: res,
});
export const setStatusShowing = (status) => ({
  type: instantReqTypes.SET_STATUS_SHOWING,
  payload: status,
});
export const clearStatusShowing = () => ({
  type: instantReqTypes.CLEAR_STATUS_SHOWING,
});
export const setResponseInstantRequestResult = (result) => ({
  type: instantReqTypes.RESPONSE_NEW_INSTANT_REQUEST_RESULT,
  payload: result,
});

// async
let fetchStatusAsync_counter = 0;
export const fetchStatusAsync = (socket, loadId) => (dispatch) => {
  dispatch(fetchStatusStart());

  socket.emit("instant_request_status", {
    load_id: loadId,
  });

  if (fetchStatusAsync_counter++ !== 0) return;
  socket.on("response_new_instant_request_result", (xxx1) => {
    console.log( "asdf",xxx1 );
    dispatch(setResponseInstantRequestResult(xxx1));
  });
  socket.on("response_instant_request_status", (res) => {
    // alert("res isnt status");
    // console.log({ FETCH_DAYSAHEAD_START });
    console.log({ mmm: res });

    dispatch(setStatusShowing(res?.status));
    dispatch(fetchStatusSuccess(res));
    if (res?.status?.code === 2) dispatch(setInstantStep(2));
    if (res?.status?.code === 1) dispatch(setInstantStep(-1));
    // dispatch(setInstantStep(2));
  });
};
